export default __webpack_public_path__ + "static/media/subcategoryImg.5f822183.png";